import React, { useState } from "react";
import "./BackendTest.css";

console.log("🔥🔥🔥 BACKEND TEST PAGE LOADED 🔥🔥🔥");

const API_BASE_URL = "https://backend.bait-coin.com";

function BackendTest() {
  // ==========================================
  // REGISTRATION STATE
  // ==========================================

  const [fullName, setFullName] = useState("Test User");
  const [phoneNumber, setPhoneNumber] = useState("03001112222");
  const [walletAddress, setWalletAddress] = useState(
    "0x22211E9B20858f744C311Bb20549736a43CC33A0"
  );

  const [registerLoading, setRegisterLoading] = useState(false);
  const [registerResult, setRegisterResult] = useState(null);

  // ==========================================
  // PHONE RESOLVER STATE
  // ==========================================

  const [lookupPhone, setLookupPhone] = useState("03001112222");

  const [lookupLoading, setLookupLoading] = useState(false);
  const [lookupResult, setLookupResult] = useState(null);

  // ==========================================
  // BACKEND HEALTH
  // ==========================================

  const [healthLoading, setHealthLoading] = useState(false);
  const [healthResult, setHealthResult] = useState(null);

  // ==========================================
  // TEST BACKEND CONNECTION
  // ==========================================

  const testBackend = async () => {
    setHealthLoading(true);
    setHealthResult(null);

    try {
      const response = await fetch(`${API_BASE_URL}/`);

      const text = await response.text();

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      setHealthResult({
        success: true,
        message: text,
      });
    } catch (error) {
      console.error("Backend health check error:", error);

      setHealthResult({
        success: false,
        message:
          "Cannot connect to backend. Make sure node index.js is running on port 3001.",
        details: error.message,
      });
    } finally {
      setHealthLoading(false);
    }
  };

  // ==========================================
  // REGISTER USER
  // ==========================================

  const registerUser = async (e) => {
    e.preventDefault();

    if (registerLoading) {
      return;
    }

    setRegisterLoading(true);
    setRegisterResult(null);

    try {
      const payload = {
        fullName: fullName.trim(),
        phoneNumber: phoneNumber.trim(),
        walletAddress: walletAddress.trim(),
      };

      console.log("==========================================");
      console.log("📱 BAIT CASH USER REGISTRATION");
      console.log("==========================================");
      console.log("Sending registration request:", payload);
      console.log(
        "Endpoint:",
        `${API_BASE_URL}/api/users/register`
      );
      console.log("==========================================");

      const response = await fetch(
        `${API_BASE_URL}/api/users/register`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(payload),
        }
      );

      let data;

      try {
        data = await response.json();
      } catch (error) {
        throw new Error(
          `Invalid backend response. HTTP ${response.status}`
        );
      }

      console.log("Registration response:", data);

      if (!response.ok) {
        throw new Error(
          data?.error ||
            data?.details ||
            data?.message ||
            `Registration failed with HTTP ${response.status}`
        );
      }

      console.log("==========================================");
      console.log("✅ USER CREATED SUCCESSFULLY");
      console.log("✅ MongoDB registration successful");
      console.log("==========================================");

      setRegisterResult({
        success: true,
        data,
      });

      // Automatically use registered phone for lookup
      setLookupPhone(phoneNumber.trim());
    } catch (error) {
      console.error("Registration error:", error);

      setRegisterResult({
        success: false,
        error:
          error?.message ||
          "Unable to register user.",
      });
    } finally {
      setRegisterLoading(false);
    }
  };

  // ==========================================
  // RESOLVE PHONE
  // ==========================================

  const resolvePhone = async (e) => {
    e.preventDefault();

    if (lookupLoading) {
      return;
    }

    setLookupLoading(true);
    setLookupResult(null);

    try {
      const payload = {
        phoneNumber: lookupPhone.trim(),
      };

      console.log("==========================================");
      console.log("📱 PHONE RESOLVER");
      console.log("==========================================");
      console.log("Sending phone resolution request:", payload);
      console.log(
        "Endpoint:",
        `${API_BASE_URL}/api/users/resolve-phone`
      );
      console.log("==========================================");

      const response = await fetch(
        `${API_BASE_URL}/api/users/resolve-phone`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(payload),
        }
      );

      let data;

      try {
        data = await response.json();
      } catch (error) {
        throw new Error(
          `Invalid backend response. HTTP ${response.status}`
        );
      }

      console.log("Phone resolution response:", data);

      if (!response.ok) {
        throw new Error(
          data?.error ||
            data?.details ||
            data?.message ||
            `Phone resolution failed with HTTP ${response.status}`
        );
      }

      setLookupResult({
        success: true,
        data,
      });
    } catch (error) {
      console.error("Phone resolution error:", error);

      setLookupResult({
        success: false,
        error:
          error?.message ||
          "Unable to resolve phone number.",
      });
    } finally {
      setLookupLoading(false);
    }
  };

  // ==========================================
  // CLEAR REGISTRATION
  // ==========================================

  const clearRegistration = () => {
    if (registerLoading) {
      return;
    }

    setRegisterResult(null);
  };

  // ==========================================
  // CLEAR LOOKUP
  // ==========================================

  const clearLookup = () => {
    if (lookupLoading) {
      return;
    }

    setLookupResult(null);
  };

  return (
    <div className="backend-test-page">

      {/* ======================================
          HEADER
      ====================================== */}

      <div className="backend-test-header">

        <div>

          <div className="backend-test-badge">
            BAIT WALLET
          </div>

          <h1>
            Backend Integration Test
          </h1>

          <p>
            Test registration, MongoDB storage and
            phone-to-wallet resolution.
          </p>

        </div>

        <div className="backend-status">

          <span className="status-dot"></span>

          API: localhost:3001

        </div>

      </div>

      {/* ======================================
          BACKEND HEALTH
      ====================================== */}

      <section className="test-card health-card">

        <div className="card-title-row">

          <div>

            <span className="section-label">
              01
            </span>

            <h2>
              Backend Connection
            </h2>

            <p>
              Check whether your Express backend is
              running correctly.
            </p>

          </div>

          <div className="connection-icon">
            ⚡
          </div>

        </div>

        <button
          type="button"
          className="primary-button"
          onClick={testBackend}
          disabled={healthLoading}
        >
          {healthLoading
            ? "Checking..."
            : "Test Backend Connection"}
        </button>

        {healthResult && (

          <div
            className={
              healthResult.success
                ? "result-box success-result"
                : "result-box error-result"
            }
          >

            <div className="result-title">

              {healthResult.success
                ? "✓ Connected"
                : "✕ Connection Failed"}

            </div>

            <div className="result-message">
              {healthResult.message}
            </div>

            {healthResult.details && (

              <div className="result-details">
                {healthResult.details}
              </div>

            )}

          </div>

        )}

      </section>

      {/* ======================================
          REGISTER USER
      ====================================== */}

      <section className="test-card">

        <div className="card-title-row">

          <div>

            <span className="section-label">
              02
            </span>

            <h2>
              Register Test User
            </h2>

            <p>
              This creates a real user document in
              your MongoDB database.
            </p>

          </div>

          <div className="connection-icon">
            👤
          </div>

        </div>

        <form onSubmit={registerUser}>

          <div className="form-group">

            <label>
              Full Name
            </label>

            <input
              type="text"
              value={fullName}
              onChange={(e) =>
                setFullName(e.target.value)
              }
              placeholder="Enter full name"
              required
              disabled={registerLoading}
            />

          </div>

          <div className="form-group">

            <label>
              Pakistan Mobile Number
            </label>

            <input
              type="tel"
              value={phoneNumber}
              onChange={(e) =>
                setPhoneNumber(e.target.value)
              }
              placeholder="03001234567"
              required
              disabled={registerLoading}
            />

            <span className="input-help">
              Example: 03001234567
            </span>

          </div>

          <div className="form-group">

            <label>
              Wallet Address
            </label>

            <input
              type="text"
              value={walletAddress}
              onChange={(e) =>
                setWalletAddress(e.target.value)
              }
              placeholder="0x..."
              required
              disabled={registerLoading}
            />

            <span className="input-help">
              Ethereum-compatible Goldchain wallet address
            </span>

          </div>

          <div className="button-row">

            <button
              type="submit"
              className="primary-button"
              disabled={registerLoading}
            >
              {registerLoading
                ? "Registering..."
                : "Register User"}
            </button>

            <button
              type="button"
              className="secondary-button"
              onClick={clearRegistration}
              disabled={registerLoading}
            >
              Clear
            </button>

          </div>

        </form>

        {registerResult && (

          <div
            className={
              registerResult.success
                ? "result-box success-result"
                : "result-box error-result"
            }
          >

            {registerResult.success ? (

              <>

                <div className="result-title">
                  ✓ User Created Successfully
                </div>

                <div className="result-message">
                  MongoDB registration was successful.
                </div>

                <div className="result-data">

                  <div className="data-row">

                    <span>
                      ID
                    </span>

                    <strong>
                      {registerResult.data?.user?.id ||
                        registerResult.data?.user?._id ||
                        "N/A"}
                    </strong>

                  </div>

                  <div className="data-row">

                    <span>
                      Full Name
                    </span>

                    <strong>
                      {registerResult.data?.user?.fullName ||
                        fullName}
                    </strong>

                  </div>

                  <div className="data-row">

                    <span>
                      Phone
                    </span>

                    <strong>
                      {registerResult.data?.user?.phoneNumber ||
                        phoneNumber}
                    </strong>

                  </div>

                  <div className="data-row wallet-row">

                    <span>
                      Wallet
                    </span>

                    <strong>
                      {registerResult.data?.user?.walletAddress ||
                        walletAddress}
                    </strong>

                  </div>

                  {registerResult.data?.user?.status && (

                    <div className="data-row">

                      <span>
                        Status
                      </span>

                      <strong>
                        {registerResult.data.user.status}
                      </strong>

                    </div>

                  )}

                </div>

              </>

            ) : (

              <>

                <div className="result-title">
                  ✕ Registration Failed
                </div>

                <div className="result-message">
                  {registerResult.error}
                </div>

              </>

            )}

          </div>

        )}

      </section>

      {/* ======================================
          PHONE RESOLVER
      ====================================== */}

      <section className="test-card">

        <div className="card-title-row">

          <div>

            <span className="section-label">
              03
            </span>

            <h2>
              Phone → Wallet Resolver
            </h2>

            <p>
              Find a registered BAIT Wallet user
              using their mobile number.
            </p>

          </div>

          <div className="connection-icon">
            📱
          </div>

        </div>

        <form onSubmit={resolvePhone}>

          <div className="form-group">

            <label>
              Phone Number
            </label>

            <input
              type="tel"
              value={lookupPhone}
              onChange={(e) =>
                setLookupPhone(e.target.value)
              }
              placeholder="03001234567"
              required
              disabled={lookupLoading}
            />

          </div>

          <div className="button-row">

            <button
              type="submit"
              className="primary-button"
              disabled={lookupLoading}
            >
              {lookupLoading
                ? "Searching..."
                : "Resolve Phone"}
            </button>

            <button
              type="button"
              className="secondary-button"
              onClick={clearLookup}
              disabled={lookupLoading}
            >
              Clear
            </button>

          </div>

        </form>

        {lookupResult && (

          <div
            className={
              lookupResult.success
                ? "result-box success-result"
                : "result-box error-result"
            }
          >

            {lookupResult.success ? (

              <>

                <div className="result-title">
                  ✓ BAIT Wallet User Found
                </div>

                <div className="recipient-card">

                  <div className="recipient-avatar">

                    {(
                      lookupResult.data?.recipientName ||
                      "B"
                    )
                      .charAt(0)
                      .toUpperCase()}

                  </div>

                  <div className="recipient-info">

                    <span className="recipient-label">
                      Recipient
                    </span>

                    <strong>
                      {lookupResult.data?.recipientName ||
                        "Unknown User"}
                    </strong>

                    <span>
                      {lookupResult.data?.phoneNumber ||
                        lookupPhone}
                    </span>

                  </div>

                </div>

                <div className="result-data">

                  <div className="data-row wallet-row">

                    <span>
                      Wallet Address
                    </span>

                    <strong>
                      {lookupResult.data?.walletAddress ||
                        "N/A"}
                    </strong>

                  </div>

                  <div className="data-row">

                    <span>
                      Phone Verified
                    </span>

                    <strong>
                      {lookupResult.data?.phoneVerified
                        ? "Yes"
                        : "No — pending verification"}
                    </strong>

                  </div>

                  {lookupResult.data?.status && (

                    <div className="data-row">

                      <span>
                        Account Status
                      </span>

                      <strong>
                        {lookupResult.data.status}
                      </strong>

                    </div>

                  )}

                </div>

              </>

            ) : (

              <>

                <div className="result-title">
                  ✕ User Not Found
                </div>

                <div className="result-message">
                  {lookupResult.error}
                </div>

              </>

            )}

          </div>

        )}

      </section>

      {/* ======================================
          TEST FLOW
      ====================================== */}

      <section className="test-card flow-card">

        <div className="card-title-row">

          <div>

            <span className="section-label">
              04
            </span>

            <h2>
              Integration Flow
            </h2>

            <p>
              This is what we are currently testing.
            </p>

          </div>

        </div>

        <div className="flow">

          <div className="flow-item">

            <div className="flow-number">
              1
            </div>

            <div>

              <strong>
                BAIT Wallet
              </strong>

              <span>
                User enters registration details
              </span>

            </div>

          </div>

          <div className="flow-line"></div>

          <div className="flow-item">

            <div className="flow-number">
              2
            </div>

            <div>

              <strong>
                Express Backend
              </strong>

              <span>
                /api/users/register
              </span>

            </div>

          </div>

          <div className="flow-line"></div>

          <div className="flow-item">

            <div className="flow-number">
              3
            </div>

            <div>

              <strong>
                MongoDB
              </strong>

              <span>
                User record is stored
              </span>

            </div>

          </div>

          <div className="flow-line"></div>

          <div className="flow-item">

            <div className="flow-number">
              4
            </div>

            <div>

              <strong>
                Phone Resolver
              </strong>

              <span>
                Phone → recipient wallet
              </span>

            </div>

          </div>

        </div>

      </section>

      <div className="backend-test-footer">

        <span>
          BAIT Wallet Backend Test
        </span>

        <span>
          MongoDB • Express • Goldchain
        </span>

      </div>

    </div>
  );
}

export default BackendTest;